/*! Twire util - MIT license  */
import { v4 as uuidv4 } from 'uuid';

export default {
	
	html: function(text) {
		
		return text.replace(/&/g, "&amp;")
				   .replace(/</g, "&lt;")
				   .replace(/>/g, "&gt;")
				   .replace(/"/g, "&quot;")
				   .replace(/'/g, "&#039;");
		
	},
	generateGUID: function() {
		
		return uuidv4();
		
	},
	getUNIXTimestamp: function() {
		
		return Math.floor(Date.now() / 1000);
		
	},
	renderImgSizes: function(selector, attribute = 'width', drp = 2) {

		// 1. selector: any jquery selector, not assuming image so things like div.parent img can be selected
		// 2. attribute: 'width; or 'height'
		// 3. dpr: Device Pixel Ratio (DPR), allow fo any type of retina

		var $img = $(selector);

		// Whitelist attribute
		if (attribute == 'height') {

			attribute = 'height';

		} else {

			attribute = 'width';

		}
		
		$img.each(function() {

			var $this = $(this);

			// Get the native value
			var property = $this.data('twire-' + attribute);

			// Convert to retina value
			property = parseInt(property / drp);

			// Add as style=""
			$this.css(attribute, property + 'px');

		});

	},
	get: async function(url, data) {

		var params = data ? '?' + new URLSearchParams(data).toString() : '';
		
		try {

			var response = await fetch(url + params, {
				method: 'GET',
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			});

			if (!response.ok) throw response;

			return await response.json();

		} catch (err) {

			throw err;

		}

	},
	post: async function(url, data, type = 'form') {

		var headers = { 'X-Requested-With': 'XMLHttpRequest' };
		var body	= data;

		if (type === 'json') {

			headers['Content-Type'] = 'application/json';

			if (typeof data !== 'string') {
				body = JSON.stringify(data);
			}

		} else {

			headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

			if (typeof data === 'object' && !(data instanceof FormData) && !(data instanceof URLSearchParams)) {
				body = new URLSearchParams(data).toString();
			}

		}

		try {

			var response = await fetch(url, {
				method: 'POST',
				headers: headers,
				body: body
			});

			if (!response.ok) throw response;

			return await response.json();

		} catch (err) {

			throw err;

		}

	},
	scrollTo: (selector, offset = 0) => {

		const target = document.querySelector(selector);

		if (!target) return;

		let offsetValue = 0;

		// Determine the offset based on type
		if (typeof offset === 'number') {

			offsetValue = offset;

		} else if (typeof offset === 'string') {

			const offsetElement = document.querySelector(offset);
			offsetValue = offsetElement ? offsetElement.offsetHeight : 0;

		}

		// Calculate the position
		const elementPosition = target.getBoundingClientRect().top + window.scrollY;
		const offsetPosition = elementPosition - offsetValue;

		// Perform the native smooth scroll
		window.scrollTo({

			top: offsetPosition,
			behavior: 'smooth'

		});

	}
	
};